// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3h-W-","label":"styles_label__1zC5R"};